import React from "react";
import Navbar from "../../components/Navbar";
import {
    GpsFixed,
    Star,
    Diamond,
    Phone,
    LocationOn,
    Smartphone,
    Email,
} from "@mui/icons-material";

function AboutPage() {
    return (
        <div className="min-h-screen relative">
            {/* Background Image */}
            <div
                className="fixed inset-0 bg-cover bg-center bg-no-repeat"
                style={{
                    backgroundImage: `url(/images/yacht-bg-2.jpg)`,
                    filter: "brightness(0.9) saturate(1.2)",
                }}
            />

            {/* Gradient Overlay */}
            <div className="fixed inset-0 bg-gradient-to-b from-gray-900/90 via-gray-900/70 to-gray-900/90" />

            {/* Content */}
            <div className="relative z-10">
                {/* <AuthButtons /> */}
                <Navbar />

                {/* Hero Section */}
                <div className="relative pt-36 pb-12 text-center text-white">
                    <h1 className="text-5xl font-bold mb-4">
                        Cyprus Yacht Club Hakkında
                    </h1>
                    <p className="text-lg text-white/60">
                        Lüks yat kiralama deneyiminde yeni bir standart
                    </p>
                </div>

                {/* Content Sections */}
                <div className="max-w-7xl mx-auto px-4 py-12">
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-12">
                        {/* Vision Section */}
                        <div className="bg-white/5 backdrop-blur-md rounded-3xl p-8 border border-white/10">
                            <div className="flex items-center mb-6">
                                <GpsFixed
                                    className="text-4xl mr-4 text-blue-400"
                                    sx={{ fontSize: 40 }}
                                />
                                <h2 className="text-2xl font-bold text-white">
                                    Vizyonumuz
                                </h2>
                            </div>
                            <p className="text-white/70 leading-relaxed">
                                Kıbrıs'ta yat kiralamada lider marka olmak,
                                tatilcilerin ve deniz tutkunu ziyaretçilerin ilk
                                tercihi haline gelmek. Vizyonumuz, yenilikçi ve
                                sürdürülebilir çözümlerle zenginleştirilmiş bir
                                platform sunarak, her yıl daha fazla turisti
                                Kıbrıs'a çekmek ve ziyaretçilerin, Kıbrıs'ın
                                eşsiz koylarında, tarihi bölgelerinde ve özgün
                                manzaralarında unutulmaz anılar biriktirmelerine
                                yardımcı olmaktır. Yerel işletmelerle iş birliği
                                yaparak, bölgenin turizm potansiyelini artırmayı
                                ve Kıbrıs'ı uluslararası bir yat turizmi merkezi
                                haline getirmeyi hedefliyoruz.
                            </p>
                        </div>

                        {/* Mission Section */}
                        <div className="bg-white/5 backdrop-blur-md rounded-3xl p-8 border border-white/10">
                            <div className="flex items-center mb-6">
                                <Star
                                    className="text-4xl mr-4 text-blue-300"
                                    sx={{ fontSize: 40 }}
                                />
                                <h2 className="text-2xl font-bold text-white">
                                    Misyonumuz
                                </h2>
                            </div>
                            <p className="text-white/70 leading-relaxed">
                                Kıbrıs'ın doğal güzelliklerini ve eşsiz deniz
                                deneyimlerini keşfetmek isteyen yerli ve yabancı
                                turistlere, kaliteli ve güvenilir yat kiralama
                                hizmetleri sunmayı taahhüt ediyoruz. Misyonumuz,
                                müşterilerimize kişiselleştirilmiş hizmetler
                                sunarak, unutulmaz bir tatil deneyimi
                                yaşamalarını sağlamak ve Kıbrıs'ı denizden
                                keşfetmelerine olanak vermektir. Yerel kültürü
                                ve doğal zenginlikleri ön plana çıkararak, deniz
                                tutkusunu herkesle paylaşmayı amaçlıyoruz.
                            </p>
                        </div>

                        {/* Why Choose Us */}
                        <div className="bg-white/5 backdrop-blur-md rounded-3xl p-8 border border-white/10 md:col-span-2">
                            <div className="flex items-center mb-8">
                                <Diamond
                                    className="text-4xl mr-4 text-blue-500"
                                    sx={{ fontSize: 40 }}
                                />
                                <h2 className="text-2xl font-bold text-white">
                                    Neden Biz?
                                </h2>
                            </div>
                            <ol className="text-white/70 list-decimal pl-6 space-y-2">
                                <li>
                                    <b>Uzmanlık ve Deneyim:</b> Bu yılla
                                    birlikte Kıbrıs'ta yat kiralama sektöründe
                                    bir ilke imza atıyoruz ve inanılmaz
                                    deneyimlerle faaliyet gösteriyoruz. Yerel
                                    bilgi birikimimizle, en iyi rotaları ve
                                    gizli koyları keşfetmenize yardımcı
                                    oluyoruz.
                                </li>
                                <li>
                                    <b>Kaliteli ve Güvenli Yatlar:</b> Yeni
                                    markamızla birlikte daha modern, düzenli
                                    bakımları yapılan ve her türlü güvenlik
                                    standartlarına uyan yatlardan oluşmaktadır.
                                    Müşterilerimizin güvenliği, bizim için en
                                    önemli öncelik.
                                </li>
                                <li>
                                    <b>Özelleştirilmiş Hizmetler:</b> Tatilinizi
                                    daha özel hale getirmek için farklı paketler
                                    sunuyoruz. İster özel yemek hizmetleri,
                                    ister su sporları aktiviteleri, ya da özel
                                    tur rehberliği talep edin, her isteğinize
                                    uygun seçeneklerle hizmetinizdeyiz.
                                </li>
                                <li>
                                    <b>Rekabetçi Fiyatlar:</b> Yüksek kaliteyi
                                    en uygun fiyatlarla sunuyoruz. Farklı
                                    bütçelere hitap eden seçeneklerimizle,
                                    herkes için erişilebilir bir tatil imkanı
                                    sunuyoruz.
                                </li>
                                <li>
                                    <b>Müşteri Memnuniyeti:</b> Önceki
                                    müşterilerimizin memnuniyeti bizim için
                                    büyük bir motivasyon kaynağıdır. Yüzde 95
                                    müşteri memnuniyeti oranımız ve aldığımız
                                    olumlu geri dönüşler, hizmet kalitemizin bir
                                    göstergesidir.
                                </li>
                                <li>
                                    <b>Yerel Kültür ve Deneyimler:</b> Yat
                                    kiralama deneyiminiz sırasında Kıbrıs'ın
                                    büyüleyici kültürünü keşfetme fırsatı
                                    bulacaksınız. Sizi yalnızca denizle değil,
                                    eşsiz yerel tatlarla da tanıştırmak için
                                    buradayız.
                                </li>
                                <li>
                                    <b>Kolay Rezervasyon Süreci:</b> Kullanıcı
                                    dostu platformumuz sayesinde, birkaç tıklama
                                    ile hızlı ve kolay bir şekilde rezervasyon
                                    yapabilirsiniz. Profesyonel müşteri
                                    hizmetlerimiz her adımda yanınızda!
                                </li>
                            </ol>
                        </div>

                        {/* Contact Info */}
                        <div className="bg-white/5 backdrop-blur-md rounded-3xl p-8 border border-white/10 md:col-span-2">
                            <div className="flex items-center mb-8">
                                <Phone
                                    className="text-4xl mr-4 text-blue-400"
                                    sx={{ fontSize: 40 }}
                                />
                                <h2 className="text-2xl font-bold text-white">
                                    İletişim
                                </h2>
                            </div>
                            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 text-white/70">
                                <div className="space-y-2">
                                    <p className="flex items-center">
                                        <LocationOn
                                            className="text-xl mr-3 text-blue-400"
                                            sx={{ fontSize: 24 }}
                                        />
                                        Girne Marina, Kuzey Kıbrıs
                                    </p>
                                </div>
                                <div className="space-y-2">
                                    <p className="flex items-center">
                                        <Smartphone
                                            className="text-xl mr-3 text-blue-500"
                                            sx={{ fontSize: 24 }}
                                        />
                                        +90 533 123 4567
                                    </p>
                                </div>
                                <div className="space-y-2">
                                    <p className="flex items-center">
                                        <Email
                                            className="text-xl mr-3 text-blue-300"
                                            sx={{ fontSize: 24 }}
                                        />
                                        cyprusyachtclub@gmail.com
                                    </p>
                                </div>
                                <div className="space-y-2">
                                    <a
                                        href="https://instagram.com/cyprusyachtclub"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="flex items-center hover:text-blue-400 transition-colors"
                                    >
                                        <svg
                                            className="text-xl mr-3 text-blue-400"
                                            width="24"
                                            height="24"
                                            viewBox="0 0 24 24"
                                            fill="currentColor"
                                        >
                                            <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z" />
                                        </svg>
                                        @cyprusyachtclub
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default AboutPage;
